import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  Projects = [
    {
      title: 'Amusement Park',
      status: 'In Progress',
      description: 'We are Building an themepark that is realistic. That means we have smooth movement in the Rides, many 3d models and love for the Details! With just data packs and resource packs!',
      img: 'assets/images/AmusementPark.png',
      routerLink: '/park'
    },
    {
      title: 'Jungle PVP',
      status: 'Finished',
      description: 'Inspired By the German Youtuber TheJoCraft and his friend Stiiidu we made a remake of their old map called Jungle PVP. You have to fight in a Jungle for an hour and the Team with the most Points wins. You get points through killing and loose them when dying',
      img: 'assets/images/Jpvp.png'
    },
    {
      title: 'Desert PVP',
      status: 'In Planning',
      description: 'As a follow up to Jungle PVP we have plans on creating Desert PvP. It works the same way but is set in a Dessert!',
      img: 'assets/images/Dpvp.png'
    },
    {
      title: 'Bow Bash',
      status: 'Finished',
      description: 'This is a Map which is inspired by yet another old minigame we used to play! Shoot or kick down other players to gain points. Fall down and loose points.',
      img: 'assets/images/BB.png'
    },
    {
      title: 'Soccer',
      status: 'In Progress',
      description: 'We have plans on creating multiple Soccer fields. But for now we just have this cute ball which you can kick around.',
      img: 'assets/images/Soccer.png'
    },
  ];

  Resources = [
    {
      title: 'Vibrant Grass',
      description: 'You always thought the Grass in minecraft looked boring? Well then you should download this pack!',
      img: 'assets/images/Grass.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787665664244449280/VibrantGrass.zip'
    },
    {
      title: 'Better Paths',
      description: 'With this pack the Paths go down blocks.',
      img: 'assets/images/Path.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787666082948448260/BetterPaths.zip'
    },
    {
      title: 'Custom Netherite',
      status: 'By: GebackeneBanane',
      description: 'With this pack you have golden parts on your netherite armor.',
      img: 'assets/images/Netherite.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787702793669574726/Custom_Netherite.zip'
    },
    {
      title: 'Better Warped Forrest',
      description: 'When activating this the warped forrest turns purple. :O',
      img: 'assets/images/Warped.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/787703054060355584/BetterWarpedForrest.zip'
    },
    {
      title: 'Golden Enchantment Glint',
      status: 'By: Olivier_286',
      description: 'This pack lets your enchanted items be golden!',
      img: 'assets/images/GoldenGlint.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/793219954278400040/Golden_Enchanting_Glint.zip'
    },
    {
      title: 'Fox to racoon',
      status: 'Requires Optifine!',
      description: 'This pack turns foxes into racoons!',
      img: 'assets/images/recourcepacks/raccoon.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/839564828062122004/RACCOOOOONS.zip'
    },
  ];

  Datapacks = [
    {
      title: 'Glowing Glowberries',
      description: 'You glow when you eat glowberries. There is not much to it :D',
      img: 'assets/images/datapacks/glow_berries.png',
      pixel: true,
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/816760523395301417/GlowingGlowberries.zip'
    },
    {
      title: 'Leash',
      description: 'You can make a Lesh out of nowhere. Just type /function tt.leash/give to give yourself the book that has everything you\'ll need. (Good for mapmaking)',
      img: 'assets/images/datapacks/lead.png',
      pixel: true,
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/816762474716069888/Leash.zip'
    },
    {
      title: '_jeb',
      description: 'With this Datapack normal sheep can have every color.',
      img: 'assets/images/datapacks/Rainbow_Sheep.png',
      loadurl: 'https://cdn.discordapp.com/attachments/787665326364033024/816763572776337418/SheepColor.zip'
    },
  ];
}

